import { useLocalStorage } from '@distribute/frontend/utils';
import { WORKSPACE_SORT } from '../../../shared/constants';
import { SORT_ITEMS } from '../config';

export const useSort = () => {
  const [sort, setSort] = useLocalStorage<keyof typeof SORT_ITEMS>(
    WORKSPACE_SORT,
    'lastModified'
  );

  return { sort, setSort };
};
